import { useInfiniteQuery } from '@tanstack/react-query';
import { listConversations } from '@/api/conversations';
import { queryKeys } from '@/lib/queryKeys';
import type { InboxFilters } from '@/features/inbox/hooks/useInboxFilters';

/**
 * Hook to fetch conversations with infinite scroll pagination
 */
export function useConversations(filters: InboxFilters) {
  return useInfiniteQuery({
    queryKey: queryKeys.conversations.list(filters),
    queryFn: ({ pageParam }) => {
      const params: Parameters<typeof listConversations>[0] = { limit: 20 };
      if (filters.status.length > 0) params.status = filters.status;
      if (filters.assignedTo !== 'all') params.assignedTo = filters.assignedTo;
      if (pageParam) params.cursor = pageParam;
      return listConversations(params);
    },
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) =>
      lastPage.pagination.has_more ? lastPage.pagination.next_cursor ?? undefined : undefined,
    select: (data) => ({
      conversations: data.pages.flatMap((page) => page.conversations),
      hasMore: data.pages[data.pages.length - 1]?.pagination.has_more ?? false,
    }),
    refetchInterval: 15_000,
    refetchIntervalInBackground: false,
  });
}
